module.exports = __webpack_public_path__ + "img/edit-icon.e4248649.png";